import React from 'react';

import { FieldOrderField, FlowOutputFieldOrderField, OrderDirection } from '../../../../../../gen-src/queries';
import { DefaultDirections, SortProviderProps, UrlSortProvider } from '../../../../data-catalog-shared';

export type FieldsValidSortFields = FieldOrderField.NAME | FlowOutputFieldOrderField.NAME;

export const FieldsDefaultDirections: DefaultDirections<FieldsValidSortFields> = {
  NAME: OrderDirection.ASC,
};

export const FieldsDefaultSortField = FieldOrderField.NAME;

export function FieldsGridSortProvider(
  props: Pick<SortProviderProps<FieldsValidSortFields>, 'children'>
): JSX.Element {
  return (
    <UrlSortProvider<FieldsValidSortFields>
      validOrderFieldsWithDefaultDirections={FieldsDefaultDirections}
      defaultField={FieldsDefaultSortField}
    >
      {props.children}
    </UrlSortProvider>
  );
}
